<template>
  <modal ref="templateUpgradeModal" @shown="onShown()" id="template-upgrade-modal" centered hide-footer hide-header content-class="templateModalRectangle">
    <template #default>
      <span class="Masthead">Select template</span>
      <p class="Byline">Work faster with templates! Quickly apply pre-defined settings around your content (customization, security and more!). Set up one from scratch or get started with one below.</p>

      <div class="d-flex flex-wrap template-upgrade-buttons">
        <template-upgrade-button icon="icons-sales.svg" title="Sales intro" class="template-upgrade-button top-row">
          Connect with customers and close more deals with personalized intro videos.
        </template-upgrade-button>

        <template-upgrade-button icon="icons-bug.svg" title="Bug report" class="template-upgrade-button top-row">
          Make bug reporting much easier by showing exactly what you are seeing.
        </template-upgrade-button>

        <template-upgrade-button icon="icons-support.svg" title="Support Response" class="template-upgrade-button">
          Speed up support and delight your customers through personal video responses.
        </template-upgrade-button>

        <template-upgrade-button icon="icons-announcement.svg" title="Announcement" class="template-upgrade-button">
          Cut through the noise and make your announcement seen and heard.
        </template-upgrade-button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@cmp/modal';
import TemplateUpgradeButton from '@cmp/viewer/template_upgrade_button.vue';

import track from "@/src/tracking.js";

export default {
  components: { TemplateUpgradeButton, Modal },
  methods: {
    onShown: function() {
    },
    track: function() {
      track('viewer_templates_modal_viewed', {
        user_id: this.$store.state.user.id,
        item_id: this.$store.state.item.id,
        org_id: this.$store.state.currentOrganization.id,
      });
    }
  },
  data: function() {
    return {
    }
  }
}
</script>

<style lang="scss">
@import "application.scss";

.nav-class {
  li {
    a {
      color: black;
    }
  }
}

.active-tab {
  border: none;
  color: #000;
  font-weight: bold;
//  padding-bottom: 3px;

  &::after {
    content: "";
    display: block;
    padding-top: 3px;
    border-bottom: 2px solid black;
    width: 70%;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
}

.modal-content.templateModalRectangle {
  padding: 0.6rem 0.6rem;
  border-radius: 16px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
  border: solid 0.5px #b5b5b5;
  background-color: $white;
}

.modal-body {
  height: 100%;
}
</style>

<style lang="scss" scoped>
@import "application.scss";

.Masthead {
  width: 14.25rem;
  height: 2.375rem;
  font-family: SFPro;
  font-size: 2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.Byline {
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 0.9rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Byline-Copy {
  width: 8.688rem;
  height: 1.5rem;
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Combined-Shape {
  width: 2rem;
  height: 2rem;
  margin: 0 1.125rem 0 0;
  background-image: linear-gradient(340deg, #24d292 92%, #d558c8 9%);
}

.LayoutTemplate-item-background {
  width: 28rem;
  height: 5.375rem;
  margin: 1rem 0;
  padding: 0.75rem 1rem 0.938rem;
  border-radius: 8px;
  box-shadow: 0 1px 8px 2px rgba(0, 0, 0, 0.07);
  background-color: $white;

  div.content {
    height: 100%;
    display: flex;
    flex-direction: row;

//    justify-content: center;

    align-items: center;
  }

  div.spacer {
    flex-grow: 1;
  }

  img.gear {
    margin-right: 5px;
    width: 1rem;
    height: 1rem;
  }

  button {
    padding: 0.7rem 1rem;
    margin: 0 0 0 0.313rem;
    font-family: SFPro;
    font-size: 0.75rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
}

.LayoutTemplate-new-item-background {
  width: 28rem;
  height: 3.75rem;
  padding: 0.563rem 0.938rem 0.688rem 0.875rem;
  border: 1px solid $bright-blue;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  img.icon {
    height: 2rem;
    width: 2rem;
    margin-right: 1rem;
  }

  button {
    font-size: 0.9rem;
    img.icon {
      height: 0.8rem;
      width: 0.8rem;
      margin-right: 0.5rem;
    }
  }
}

div.title {
  height: 100%;
  flex-grow: 1;
}

.Template-item-title {
  width: 11.313rem;
  height: 1.5rem;
  font-family: SFPro;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;

  &.new-item {
    color: $bright-blue;
  }
}

br.short {
  line-height: 5px;
}

.Template-item-description {
  width: 14.125rem;
  height: 1rem;
  font-family: SFPro;
  font-size: 0.75rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #000000;
  display: block;

  &.new-item {
    color: $bright-blue;
  }
}

.template-upgrade-buttons {
  position: relative;
  width: 100%;
  justify-content: space-between;

  .top-row {
    margin-bottom: 1.3rem;
  }
}

.template-upgrade-button {
  width: 47%;
}

.feedback-link-wrapper {
  font-family: SFPro;
  padding-top: 1rem;
  text-align: right;
}
</style>
